import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=0e49331b&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=ts&"
export * from "./CustomerService.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=0e49331b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e49331b",
  null
  
)

export default component.exports